import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_BA.json';
import audios from './ASTROLOGY_AUDIOS_BA.json';

export const ASTROLOGY_DATA_BA: ServiceData = {
  articles,
  audios,
};
